module.exports = __webpack_public_path__ + "static/media/compound_v2.1f7fc9b7.svg";